// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"8f7cd7ad","787":"9fd605a0","802":"bcc8b464"}[chunkId] + ".chunk.js";
};